import React from 'react'
import { PrefersProps } from './type'
import { Container } from '@/components/base/gridview'

const UlupinarPrefers: React.FC<PrefersProps> = ({
  title,
  description,
  data,
}) => {
  return (
    <div className="UlupinarSlider">
      <Container size="medium">
        <div className="UlupinarSlider-head">
          <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <div
          className="UlupinarSlider-desc"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div className="Ulupinar-Prefers">
          {data.map((item, index) => (
            <div className="Ulupinar-Prefers-item" key={index}>
              <div dangerouslySetInnerHTML={{ __html: item.item }} />
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default UlupinarPrefers
